import { render, staticRenderFns } from "./OtherDrafts.vue?vue&type=template&id=60b12a34"
import script from "./OtherDrafts.vue?vue&type=script&lang=js"
export * from "./OtherDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports